import formatCurrency from './formatCurrency'
import humanReadableTime from './humanReadableTime'
import { RebuttalState } from '../../types'
import roundDollarsInString from './roundDollarsInString'
import getStateName from './fullStateName'
import spanishHumanReadableTime from './spanishHumanRedableTime'

export default function replaceScriptVariables(
  rs: RebuttalState,
  incomingHTML: string,
  language: string,
) {
  const humanReadableVariant =
    language === 'en' ? humanReadableTime : spanishHumanReadableTime

  const html = incomingHTML
    .replace(
      /{TOTAL_OWED}/g,
      roundDollarsInString(formatCurrency(rs.totalOwed || 0), 1000),
    )
    .replace(/{MONTHS_PAID}/g, (rs.yearsPaid * 12 + rs.monthsPaid).toString())
    .replace(
      /{TOTAL_PAID}/g,
      roundDollarsInString(
        formatCurrency(
          Math.round(
            (rs.monthlyPayment * (rs.yearsPaid * 12 + rs.monthsPaid) || 0) /
              1000,
          ) * 1000,
        ),
        1000,
      ),
    )
    .replace(
      /{TOTAL_PAID_STRICT}/g,
      formatCurrency(
        Math.round(
          (rs.monthlyPayment * (rs.yearsPaid * 12 + rs.monthsPaid) || 0) /
            (rs.yearsPaid === 0 ? 100 : 1000),
        ) * (rs.yearsPaid === 0 ? 100 : 1000),
      ),
    )
    .replace(
      /{PRINCIPAL_SAVINGS}/g,
      roundDollarsInString(
        formatCurrency(rs.debtOwed - rs.programTotal || 0),
        1000,
      ),
    )
    .replace(
      /{TOTAL_SAVINGS}/g,
      roundDollarsInString(
        formatCurrency(rs.totalOwed - rs.programTotal || 0),
        1000,
      ),
    )
    .replace(/{PROGRAM_LENGTH}/g, rs.programLength.toString())
    .replace(
      /{PROGRAM_SAVINGS}/g,
      roundDollarsInString(
        formatCurrency(
          (rs.monthlyPayment - rs.programPayment) * rs.programLength || 0,
        ),
        1000,
      ),
    )
    .replace(/{MONTHLY_PAYMENT}/g, formatCurrency(rs.monthlyPayment || 0))
    .replace(
      /{DEBT_OWED}/g,
      roundDollarsInString(formatCurrency(rs.debtOwed || 0), 1000),
    )
    .replace(
      /{2X_TOTAL_DEBT}/g,
      roundDollarsInString(formatCurrency(rs.debtOwed * 2 || 0), 1000),
    )
    .replace(
      /{DEBT_AMOUNT}/g,
      roundDollarsInString(formatCurrency(rs.debtOwed || 0), 1000),
    )
    .replace(/{YEARS}/g, rs.yearsPaid.toString())
    .replace(/{MONTHS}/g, rs.monthsPaid.toString())
    .replace(/{PROGRAM_TERM}/g, rs.programLength.toString())
    .replace(
      /{PROGRAM_PAYMENT}/g,
      //roundDollarsInString(
      formatCurrency(rs.programPayment || 0),
      //  1000
      //),
    )
    .replace(
      /{PROGRAM_COST}/g,
      formatCurrency(rs.programPayment * rs.programLength),
    )
    .replace(
      /{MONTHLY_SAVINGS}/g,
      // roundDollarsInString(
      formatCurrency(rs.monthlyPayment - rs.programPayment || 0),
      // 1000,
      // ),
    )
    .replace(
      /{MONTHLY_SAVINGS_STRICT}/g,
      formatCurrency(rs.monthlyPayment - rs.programPayment),
    )
    .replace(/{YEARS_APX}/g, Math.floor(rs.programLength / 12 + 0.5).toString())
    .replace(
      /{TIME_HUMAN_READABLE}/g,
      humanReadableVariant(rs.yearsPaid, rs.monthsPaid),
    )
    .replace(
      /{PROGRAM_TIME_HUMAN_READABLE}/g,
      humanReadableVariant(
        Math.floor(rs.programLength / 12),
        rs.programLength % 12,
      ),
    )
    .replace(
      /{DEBT_TAX}/g,
      roundDollarsInString(formatCurrency((rs.debtOwed / 2) * 0.15), 1000),
    )
    .replace(
      /{DEBT_TAX_SAVINGS}/g,
      roundDollarsInString(
        formatCurrency(rs.totalOwed - (rs.debtOwed / 2) * 0.15),
        1000,
      ),
    )
    .replace(/{ANNUAL_PAYMENT}/g, formatCurrency(rs.monthlyPayment * 12))
    .replace(/{HALF_YEAR_PAYMENT}/g, formatCurrency(rs.monthlyPayment * 6))
    .replace(
      /{HALF_YEAR_PROGRAM_PAYMENT}/g,
      formatCurrency(rs.programPayment * 6),
    )
    .replace(
      /{HALF_YEAR_SAVINGS}/g,
      formatCurrency((rs.monthlyPayment - rs.programPayment) * 6),
    )
    .replace(
      /{THREE_YEAR_SAVINGS}/g,
      formatCurrency((rs.monthlyPayment - rs.programPayment) * 36),
    )
    .replace(/{STATE}/g, getStateName(rs.state))
    .replace(/{LOAN_AMOUNT}/, formatCurrency(rs.loanAmount))
    .replace(/{LOAN_TERM}/, rs.loanLength.toString())
    .replace(/{LOAN_MONTHLY_PAYMENT}/, formatCurrency(rs.loanPayment))
  return html
}
